var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ResendInvitationConfirmation", {
    attrs: { givenName: _vm.givenName, familyName: _vm.familyName },
    on: { confirmed: _vm.resendInvitation },
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function ({ confirm }) {
            return [
              _vm._t(
                "default",
                function () {
                  return [
                    _c("ResendInvitationNew", {
                      attrs: { processing: _vm.processing },
                      on: { resendInvitationClicked: confirm },
                    }),
                  ]
                },
                {
                  resendInvitation: confirm,
                  processing: _vm.processing,
                  invitationResent: _vm.invitationResent,
                }
              ),
            ]
          },
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }